// extracted by mini-css-extract-plugin
module.exports = {"block":"PaymentMethodsFooter_block__3-I0t"};